import React from "react";

import CopyIcon from "../../../../assets/icons/copy.svg";
const Copy = (props) => {
  return (
    <div className="ml-auto copy" onClick={props.copyFieldHandler}>
      <img src={CopyIcon} alt="copy" />
    </div>
  );
};

export default Copy;
